import React, { useState, useEffect } from "react";
import "../../Styles/Integration.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { toast, ToastContainer } from "react-toastify";

export default function SwitchExample() {
  const [isLoading, setIsLoading] = useState(false);

  // 1. Internal State
  const [settingsData, setSettingsData] = useState({
    merchant_id: "",
    publickey: "",
    privatekey: "",
    accountid: "",
    gateway_type: "razorpay",
    transaction_charge: 0,

    // here add m-pesa logic
    consumer_key: "",
    consumer_secret: "",
    short_code: "",

    online_payment: 0,
    cashless: 0,
    gateway_status: 0,
    settings_sms_gateway_status: 0,

    max_balance_limit: 0,
    min_balance_limit: 0,
    max_transaction: 0,

    gateway_username: "",
    gateway_password: "",
    gateway_sender_id: "",

    // here infonysolutions logic add
    sms_gateway_type: "",
    api_key: "",
    partner_id: "",
    short_code_sms: "",

    // here add quickbook logic a
    quickbook_mode: 0,
    quickbook_client_id: "",
    quickbook_client_secret: "",
  });

  useEffect(() => {
    fetchIntegrationSettings();
  }, []);

  // 2. Fetch API data and map from the new JSON structure
  const fetchIntegrationSettings = async () => {
    setIsLoading(true);

    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
    };

    try {
      const response = await simplePostCall(
        ApiConfig.parentintegrationsettingsget,
        JSON.stringify(requestBody),
      );

      if (response?.result) {
        const settings = response.settingsModel?.[0] || {};
        const gateway = response.gatewaymodel?.[0] || {};
        const sms = response.smsgatewayModel?.[0] || {};

        setSettingsData({
          // Map from settingsModel
          online_payment: Number(settings.settings_online_payment) || 0,
          cashless: settings.settings_cashless || 0,
          max_balance_limit: settings.settings_maximum_balance_limit || 0,
          min_balance_limit: settings.settings_minimum_balance_limit || 0,
          max_transaction: settings.settings_max_transactions || 0,
          settings_sms_gateway_status:
            settings.settings_sms_gateway_status || 0,
          gateway_type: settings.settings_payment_gateway || "razorpay",

          // Map from gatewaymodel
          merchant_id: gateway.payment_gateway_merchant_id || "",
          publickey: gateway.payment_gateway_publickey || "",
          privatekey: gateway.payment_gateway_privatekey || "",
          accountid: gateway.payment_gateway_accountid || "",
          transaction_charge:
            Number(gateway.paymant_gateway_transaction_charge) || 0,

          //  ADD THIS — M-Pesa fields
          // consumer_key: gateway.consumer_key || "",
          // consumer_secret: gateway.consumer_secret || "",
          // short_code: gateway.short_code || "",

          // Map from smsgatewayModel
          gateway_username: sms.sms_gateway_username || "",
          gateway_password: sms.sms_gateway_password || "",
          gateway_sender_id: sms.sms_gateway_sender_id || "",

          //  ADD THIS — Infonyesolution mapping
          // sms_gateway_type: sms.gateway_type || "",
          // api_key: sms.api_key || "",
          // partner_id: sms.partner_id || "",
          // short_code_sms: sms.short_code || "",
        });
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // 3. Save settings
  const handleUpdateSettings = async () => {
    setIsLoading(true);

    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),

      PaymantGatewayOptions: {
        merchant_id: settingsData.merchant_id,
        publickey: settingsData.publickey,
        privatekey: settingsData.privatekey,
        accountid: settingsData.accountid,
        gateway_type: settingsData.gateway_type,
        transaction_charge: settingsData.transaction_charge,

        // logic add m-pesa
        consumer_key: settingsData.consumer_key,
        consumer_secret: settingsData.consumer_secret,
        short_code: settingsData.short_code,
      },

      settings: {
        online_payment: settingsData.online_payment,
        cashless: settingsData.cashless,
        max_balance_limit: settingsData.max_balance_limit,
        min_balance_limit: settingsData.min_balance_limit,
        gateway_status: settingsData.gateway_status,
        settings_sms_gateway_status: settingsData.settings_sms_gateway_status,
      },

      smsgateway: {
        gateway_username: settingsData.gateway_username,
        gateway_password: settingsData.gateway_password,
        gateway_sender_id: settingsData.gateway_sender_id,
      },
    };

    try {
      const response = await simplePostCall(
        ApiConfig.integrationsettings,
        JSON.stringify(requestBody),
      );

      if (response?.result) {
        toast.success("Settings updated successfully!");
      } else {
        toast.error("Failed to update settings");
      }
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  // 4. Handle input change
  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;

    setSettingsData((prev) => ({
      ...prev,
      [id]: type === "checkbox" ? (checked ? 1 : 0) : value,
    }));
  };

  return (
    <>
      <div className="special-header bg-white mt-4 mb-4 p-2">
  <ToastContainer />

  <div className="d-flex justify-content-between align-items-center">
    
    {/* LEFT SIDE */}
    <div>
      <h4 className="fw-bold m-0">Integration Settings</h4>
    </div>

    {/* RIGHT SIDE */}
    <div>
      <button
        onClick={handleUpdateSettings}
        className="btn custom-btn"
        disabled={isLoading}
      >
        {isLoading ? "Saving..." : "Save changes"}
      </button>
    </div>

  </div>
</div>

      <div className={`card integra-back p-4 ${isLoading ? "opacity-50" : ""}`}>
        {/* Payment Settings */}
        <div className="border p-3 mb-4 rounded">
          <h6>Payment Settings</h6>

          <div className="form-check form-switch mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="online_payment"
              checked={settingsData.online_payment === 1}
              onChange={handleChange}
            />
            <label className="form-check-label">
              {settingsData.online_payment === 1
                ? "Online Payment Active"
                : "Activate Online Payment"}
            </label>
          </div>

          {settingsData.online_payment === 1 && (
            <div className="row">
              <div className="col-md-6 mb-2">
                <label>Payment Gateway</label>
                <select
                  className="form-select"
                  id="gateway_type"
                  value={settingsData.gateway_type}
                  onChange={handleChange}
                >
                  <option value="razorpay">RazorPay</option>
                  <option value="mpesa">M-Pesa</option>
                  <option value="paypal">PayPal</option>
                </select>
              </div>

              {settingsData.gateway_type === "mpesa" ? (
                <>
                  <div className="col-md-6 mb-2">
                    <label>Consumer Key</label>
                    <input
                      type="text"
                      className="form-control"
                      id="consumer_key"
                      value={settingsData.consumer_key}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-2">
                    <label>Consumer Secret</label>
                    <input
                      type="text"
                      className="form-control"
                      id="consumer_secret"
                      value={settingsData.consumer_secret}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-2">
                    <label>Short Code</label>
                    <input
                      type="text"
                      className="form-control"
                      id="short_code"
                      value={settingsData.short_code}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-2">
                    <label>Lipa Na Mpesa Online Passkey</label>
                    <input
                      type="text"
                      className="form-control"
                      // id="short_code"
                      // value={settingsData.short_code}
                      // onChange={handleChange}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="col-md-6 mb-2">
                    <label>Merchant ID</label>
                    <input
                      type="text"
                      className="form-control"
                      id="merchant_id"
                      value={settingsData.merchant_id}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-2">
                    <label>Public Key</label>
                    <input
                      type="text"
                      className="form-control"
                      id="publickey"
                      value={settingsData.publickey}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-2">
                    <label>Private Key</label>
                    <input
                      type="text"
                      className="form-control"
                      id="privatekey"
                      value={settingsData.privatekey}
                      onChange={handleChange}
                    />
                  </div>
                </>
              )}
            </div>
          )}
        </div>

        {/* Cashless Settings */}
        <div className="border p-3 mb-4 rounded">
          <h6>Cashless Settings</h6>

          <div className="form-check form-switch mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="cashless"
              checked={settingsData.cashless === 1}
              onChange={handleChange}
            />
            <label className="form-check-label">
              Cashless Enabled: {settingsData.cashless === 1 ? "YES" : "NO"}
            </label>
          </div>

          {settingsData.cashless === 1 && (
            <div className="row">
              <div className="col-md-6 mb-2">
                <label>Max Balance</label>
                <input
                  type="number"
                  className="form-control"
                  id="max_balance_limit"
                  value={settingsData.max_balance_limit}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 mb-2">
                <label>Min Balance</label>
                <input
                  type="number"
                  className="form-control"
                  id="min_balance_limit"
                  value={settingsData.min_balance_limit}
                  onChange={handleChange}
                />
              </div>
            </div>
          )}
        </div>

        {/* SMS Gateway */}
        <div className="border p-3 mb-4 rounded">
          <h6>SMS Gateway</h6>

          <div className="form-check form-switch mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="settings_sms_gateway_status"
              checked={settingsData.settings_sms_gateway_status === 1}
              onChange={handleChange}
            />
            <label className="form-check-label">SMS Status</label>
          </div>

          {settingsData.settings_sms_gateway_status === 1 && (
            <div className="row">
              {/* Gateway Dropdown */}
              <div className="col-md-6 mb-2">
                <label>SMS Gateway</label>
                <select
                  className="form-select"
                  id="sms_gateway_type"
                  value={settingsData.sms_gateway_type}
                  onChange={handleChange}
                >
                  <option value="">Select SMS Gateway</option>
                  <option value="infonyesolution">Infonyesolution</option>
                </select>
              </div>

              {settingsData.sms_gateway_type === "infonyesolution" ? (
                <>
                  <div className="col-md-6 mb-2">
                    <label>API Key</label>
                    <input
                      type="text"
                      className="form-control"
                      id="api_key"
                      value={settingsData.api_key}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-2">
                    <label>Partner ID</label>
                    <input
                      type="text"
                      className="form-control"
                      id="partner_id"
                      value={settingsData.partner_id}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-2">
                    <label>Short Code</label>
                    <input
                      type="text"
                      className="form-control"
                      id="short_code_sms"
                      value={settingsData.short_code_sms}
                      onChange={handleChange}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="col-md-6 mb-2">
                    <label>Username</label>
                    <input
                      type="text"
                      className="form-control"
                      id="gateway_username"
                      value={settingsData.gateway_username}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-2">
                    <label>Password</label>
                    <input
                      type="password"
                      className="form-control"
                      id="gateway_password"
                      value={settingsData.gateway_password}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-2">
                    <label>Sender ID</label>
                    <input
                      type="text"
                      className="form-control"
                      id="gateway_sender_id"
                      value={settingsData.gateway_sender_id}
                      onChange={handleChange}
                    />
                  </div>
                </>
              )}
            </div>
          )}
        </div>

        {/* Quickbook */}
      <div className="border p-3 mb-4 rounded">
  <h6>Quickbook Settings</h6>

  <div className="form-check form-switch mb-3">
    <input
      className="form-check-input"
      type="checkbox"
      id="quickbook_mode"
      checked={settingsData.quickbook_mode === 1}
      onChange={handleChange}
    />
    <label className="form-check-label">
      Mode: {settingsData.quickbook_mode === 1 ? "LIVE" : "SANDBOX"}
    </label>
  </div>

  {settingsData.quickbook_mode === 1 && (
    <>
      {/* Client Fields */}
      <div className="row">
        <div className="col-md-6 mb-2">
          <label>Client ID</label>
          <input
            type="text"
            className="form-control"
            id="quickbook_client_id"
            value={settingsData.quickbook_client_id}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6 mb-2">
          <label>Client Secret Code</label>
          <input
            type="text"
            className="form-control"
            id="quickbook_client_secret"
            value={settingsData.quickbook_client_secret}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* Token Box */}
      <div className="p-0">
        <pre
          className="bg-light p-2 border rounded text-dark"
          style={{ overflowX: "auto" }}
        >
          No Access Token Generated Yet
        </pre>

        {/* Buttons */}
        <div className="mt-3">
          <div className="d-flex flex-wrap gap-2 justify-content-end">
            <button
              type="submit"
              name="save_quickbook"
              className="btn custom-btn"
            >
              Update
            </button>

            <button type="button" className="btn" style={{backgroundColor: "#5db2e8", color: "white"}}>
              Connect To QuickBook
            </button>

            <a href="#" className="btn" style={{backgroundColor: "#5db2e8", color: "white"}}>
              ReConnect To QuickBook
            </a>
          </div>
        </div>
      </div>
    </>
  )}
</div>

        
      </div>
    </>
  );
}
